/* tslint:disable */
/* eslint-disable */
/* @relayHash e71cc77f1aa79411f47c53c49cf46494 */

import { ConcreteRequest } from "relay-runtime";
export type EditNewslettersInput = {
    userServiceId: string;
    emailToken?: string | null;
    promotional?: boolean | null;
    favoriteSearches?: boolean | null;
    favoriteDealers?: boolean | null;
    trade?: boolean | null;
    smsOptin?: boolean | null;
    orderFeedbackMailOptin?: boolean | null;
    clientMutationId?: string | null;
};
export type subscribeUserMutationVariables = {
    input: EditNewslettersInput;
};
export type subscribeUserMutationResponse = {
    readonly editNewsletters: {
        readonly clientMutationId: string | null;
    } | null;
};
export type subscribeUserMutation = {
    readonly response: subscribeUserMutationResponse;
    readonly variables: subscribeUserMutationVariables;
};



const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "EditNewslettersPayload",
    "kind": "LinkedField",
    "name": "editNewsletters",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "clientMutationId",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "subscribeUserMutation",
    "selections": (v1/*: any*/),
    "type": "Mutations",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "subscribeUserMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "id": "ferrum/308.0.0-2021-03-31T20:41:47.556Z/subscribeUserMutation",
    "metadata": {},
    "name": "subscribeUserMutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();
(node as any).hash = 'c9543e77c781df16904396e3a1064187';
export default node;
